import "./FamilySupport.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheGoldenYearsStory from "./sections/TheGoldenYearsStory";
import DentalExcellenceFaq from "./sections/DentalExcellenceFaq";
import RequestACaregiver from "./sections/RequestACaregiver";
import Footer from "@/reusable_sections/Footer";
export default function FamilySupportPage() {
  return <div>
      <MainNavigation />
      <TheGoldenYearsStory />
      <DentalExcellenceFaq />
      <RequestACaregiver />
      <Footer />
    </div>;
}